import { useState, useCallback, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faAward, faChartLine, faChartPie, faWaveSquare } from '@fortawesome/free-solid-svg-icons';

import Descargas from '../../components/Dashboard/Charts/Descargas';
import Estadisticas from '../../components/Dashboard/Estadisticas';
import Tops from '../../components/Dashboard/Tops';
import Proyectos from '../../components/Dashboard/Charts/Proyectos';
import TiposInformacion from '../../components/Dashboard/Charts/TiposInformacion';
import Anios from '../../components/Dashboard/Charts/Anios';
import Regiones from '../../components/Dashboard/Charts/Regiones';
import Spinner from '../../components/Spinner';

import Sidebav from '../../layouts/Sidenav';

import axios from 'axios';

const DashboardAcuiculturaPage = ({ verifyToken }) =>
{
    const [fetch, setFetch] = useState(false);
    const [estadisticas, setEstadisticas] = useState([]);
    const [table, setTable] = useState([]);
    const [chart, setChart] = useState({});
    const [loading, setLoading] = useState(false);

    const appDebug = process.env.REACT_APP_DEBUG;
    const apiUrl = process.env.REACT_APP_API_URL;
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const division = '/acuicultura';

    const fetchData = useCallback(async () =>
    {
        setFetch(true);

        try
        {
            const responseEstadisticas = await axios.get(`${apiUrl}/v2/acuicultura/estadisticas`);

            const estadisticas = verifyToken(responseEstadisticas, appDebug, secretKey);

            if (estadisticas.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setEstadisticas(estadisticas.data);

            const table = {};

            const responseRanking = await axios.get(`${apiUrl}/v2/acuicultura/ranking?limit=5`);

            const ranking = verifyToken(responseRanking, appDebug, secretKey);

            if (ranking.length === 0) { return console.log(new Error('Signature is not valid.')); }

            table.rankingProyectos = ranking.proyectos;
            table.rankingTiposInformacion = ranking.tipos_informacion;
            table.rankingAnios = ranking.anios;
            table.rankingRegiones = ranking.regiones;

            setTable(table);

            const chart = {};

            const responseQueryParams = await axios.get(`${apiUrl}/v2/acuicultura/ranking?total=1&order=desc&limit=6`);

            const queryParams = verifyToken(responseQueryParams, appDebug, secretKey);

            if (queryParams.length === 0) { return console.log(new Error('Signature is not valid.')); }

            chart.descargas = queryParams.descargas.map(descarga => descarga.FECHA);
            chart.registrosDescargas = queryParams.descargas.map(descarga => descarga.REGISTROS);
            chart.megabytesDescargas = queryParams.descargas.map(descarga => descarga.MEGABYTES);
            chart.proyectos = queryParams.proyectos.map(proyecto => proyecto.NOMBRE);
            chart.registrosProyectos = queryParams.proyectos.map(proyecto => proyecto.REGISTROS);
            chart.porcentajeProyectos = queryParams.proyectos.map(proyecto => proyecto.PORCENTAJE);
            chart.tiposInformacion = queryParams.tipos_informacion.map(tipoInformacion => tipoInformacion.TIPO_INFORMACION);
            chart.registrosTiposInformacion = queryParams.tipos_informacion.map(tipoInformacion => tipoInformacion.REGISTROS);
            chart.porcentajeTiposInformacion = queryParams.tipos_informacion.map(tipoInformacion => tipoInformacion.PORCENTAJE);
            chart.anios = queryParams.anios.map(anio => anio.ANIO);
            chart.registrosAnios = queryParams.anios.map(anio => anio.REGISTROS);
            chart.regiones = queryParams.regiones.map(region => region.NOMBRE);
            chart.registrosRegiones = queryParams.regiones.map(region => region.REGISTROS);

            setChart(chart);
            setLoading(true);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken]);

    useEffect(() =>
    {
        fetch === false && fetchData();
    }, [fetchData, fetch]);

    const Dashboard = () =>
    {
        return(
            <div className="container-fluid px-4 pt-3 pb-4" style={{ backgroundColor: '#f8f9fb' }}>

                {
                    loading ?
                    (
                        <>
                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 gap-3">
                                <div>
                                    <h1 className="h3 mb-2 fw-bold text-dark">Dashboard General</h1>
                                    <p className="text-muted mb-0">Tendencias e indicadores principales para el área acuícola.</p>
                                </div>
                            </div>

                            {
                                chart.descargas && chart.registrosDescargas &&
                                (
                                    <div className="card border-0 shadow-sm rounded-5 mb-4 overflow-hidden">
                                        <div className="card-header rounded-top-5 bg-white border-bottom d-flex align-items-center gap-2">
                                            <FontAwesomeIcon className="text-primary" icon={faChartLine} />
                                            <span className="fw-semibold">Descargas recientes</span>
                                        </div>
                                        <div className="card-body p-3 p-lg-4">
                                            <Descargas labels={chart.descargas} data={chart.registrosDescargas} megabytes={chart.megabytesDescargas} />
                                        </div>
                                    </div>
                                )
                            }

                            <div className="d-flex align-items-center justify-content-center gap-3 text-secondary my-4">
                                <div className="border-top flex-grow-1"></div>
                                <span className="badge rounded-pill py-2 px-4 fw-semibold text-secondary bg-white border border-secondary shadow-sm" style={{ fontSize: '0.85rem' }}>
                                    Rankings
                                </span>
                                <div className="border-top flex-grow-1"></div>
                            </div>

                            <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-4 justify-content-around g-4 mb-4">

                                {
                                    estadisticas?.map((estadistica, index) =>
                                    (
                                        <Estadisticas
                                            key={index}
                                            col={'col'}
                                            card={'card border-0 shadow-sm rounded-5 overflow-hidden mb-4 h-100'}
                                            header={estadistica.titulo}
                                            body={estadistica.data}
                                            link={estadistica.link}
                                        />
                                    ))
                                }

                            </div>

                            <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-4">

                                {
                                    table.rankingProyectos &&
                                    (
                                        <Tops id={'proyectos'} top={'Top 5: Proyectos'} item={'Nombre'} ranking={table.rankingProyectos} />
                                    )
                                }

                                {
                                    table.rankingTiposInformacion &&
                                    (
                                        <Tops id={'tipos-informacion'} top={'Top 5: Tipos de Información'} item={'Nombre'} ranking={table.rankingTiposInformacion} />
                                    )
                                }

                                {
                                    table.rankingRegiones &&
                                    (
                                        <Tops id={'regiones'} top={'Top 5: Regiones'} item={'Nombre'} ranking={table.rankingRegiones} />
                                    )
                                }

                                {
                                    table.rankingAnios &&
                                    (
                                        <Tops id={'anios'} top={'Top 5: Años'} item={'Año'} ranking={table.rankingAnios} />
                                    )
                                }

                            </div>

                            <div className="d-flex align-items-center justify-content-center gap-3 text-secondary my-4">
                                <div className="border-top flex-grow-1"></div>
                                    <span className="badge rounded-pill py-2 px-4 fw-semibold text-secondary bg-white border border-secondary shadow-sm" style={{ fontSize: '0.85rem' }}>
                                        <FontAwesomeIcon icon={faWaveSquare} className="me-2" />
                                        Tendencias
                                    </span>
                                <div className="border-top flex-grow-1"></div>
                            </div>

                            {
                                chart.proyectos && chart.registrosProyectos &&
                                    chart.tiposInformacion && chart.registrosTiposInformacion &&
                                    (
                                        <div className="row g-4 mb-4">
                                            <div className="col-12 col-lg-6">
                                                <Proyectos labels={chart.proyectos} data={chart.registrosProyectos} />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <TiposInformacion labels={chart.tiposInformacion} data={chart.registrosTiposInformacion} />
                                            </div>
                                        </div>
                                    )
                            }

                            {
                                chart.anios && chart.registrosAnios &&
                                    chart.regiones && chart.registrosRegiones &&
                                    (
                                        <div className="row g-4">
                                            <div className="col-12 col-xl-6">
                                                <Anios labels={chart.anios} data={chart.registrosAnios} />
                                            </div>
                                            <div className="col-12 col-xl-6">
                                                <Regiones col={'col-12'} labels={chart.regiones} data={chart.registrosRegiones} />
                                            </div>
                                        </div>
                                    )
                            }

                        </>
                    ) :
                    (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner />
                        </div>
                    )
                }

            </div>
        );
    }

    return (
        <Sidebav Dashboard={Dashboard} />
    );
}

export default DashboardAcuiculturaPage;
